<div class="reservation-container">

  <app-dynamic-form
  [formGroup]="reservationForm"
  [formConfig]="reservationDynamicformConfig"
  >
</app-dynamic-form>

</div>